// Check if required elements exist before running any code
const contentContainer = document.querySelector(".content__container__list");
const contentElement = document.querySelector(".content");

// Early exit if elements don't exist (blog pages, etc.)
if (!contentContainer || !contentElement) {
  // Silently exit - this page doesn't have hero text animation elements
} else {
  // Only declare variables and run code if elements exist
  let masterTimeline;
  let resizeTimeout;
  const listItems = document.querySelectorAll(
    ".content__container__list__item"
  );

  // Additional check for list items
  if (listItems.length === 0) {
  } else {
    function getItemHeight() {
      // Get the actual height of the first list item based on current Tailwind styles
      if (listItems.length > 0) {
        const itemRect = listItems[0].getBoundingClientRect();
        return itemRect.height;
      }
      return 120; // fallback
    }

    function updateContainerHeight() {
      // Update the container height to match the item height for Tailwind compatibility
      const itemHeight = getItemHeight();
      const container = document.querySelector(".content");
      if (container) {
        container.style.height = `${itemHeight}px`;
      }
    }

    function createAnimation() {
      // Verify elements still exist (in case of dynamic content changes)
      const currentContentContainer = document.querySelector(
        ".content__container__list"
      );
      const currentListItems = document.querySelectorAll(
        ".content__container__list__item"
      );

      if (!currentContentContainer || currentListItems.length === 0) {
        return; // Exit if elements no longer exist
      }

      // Kill existing timeline
      if (masterTimeline) {
        masterTimeline.kill();
      }

      // Wait a tick for Tailwind styles to fully apply, then get dimensions
      requestAnimationFrame(() => {
        // Update container height first
        updateContainerHeight();

        // Get current item height dynamically from Tailwind-styled elements
        const itemHeight = getItemHeight();

        masterTimeline = gsap.timeline({
          repeat: -1,
        });

        // Set initial positions - with additional safety checks
        const listElement = document.querySelector(".content__container__list");
        if (listElement) {
          gsap.set(listElement, { y: 0 });
        }

        // Check for word-text-fill elements
        const wordTextFills = document.querySelectorAll(".word-text-fill");
        if (wordTextFills.length > 0) {
          gsap.set(".word-text-fill", {
            height: "0%",
          });
        }

        const cycleDuration = 2.5; // duration for each word

        currentListItems.forEach((item, index) => {
          const wordFill = item.querySelector(".word-text-fill");

          // Only proceed if wordFill exists
          if (!wordFill) {
            return; // Skip this iteration if word-text-fill doesn't exist
          }

          // Calculate timing for each word
          const startTime = index * cycleDuration;

          // Reset the PREVIOUS word's fill when moving to current word
          if (index > 0) {
            const prevWordFill =
              currentListItems[index - 1].querySelector(".word-text-fill");
            if (prevWordFill) {
              masterTimeline.call(
                () => {
                  gsap.set(prevWordFill, {
                    height: "0%",
                  });
                },
                null,
                startTime
              );
            }
          }

          // Add word animation to timeline
          masterTimeline
            // Move list to show current word with elastic ease
            .to(
              ".content__container__list",
              {
                y: -index * itemHeight,
                duration: 0.5,
                ease: "elastic.out(1, 0.6)",
              },
              startTime
            )

            // Animate green text height to reveal from bottom to top
            .to(
              wordFill,
              {
                height: "100%",
                duration: 1.5,
                ease: "power2.inOut",
              },
              startTime + 0.2
            )

            // Hold the filled state
            .to({}, { duration: 0.5 }, startTime + 1.7);
        });

        // Add final transition back to first word for seamless loop
        const totalDuration = currentListItems.length * cycleDuration;

        // Reset the last word's fill when transitioning back to first
        const lastWordFill =
          currentListItems[currentListItems.length - 1].querySelector(
            ".word-text-fill"
          );
        if (lastWordFill) {
          masterTimeline.call(
            () => {
              gsap.set(lastWordFill, {
                height: "0%",
              });
            },
            null,
            totalDuration - 0.3
          );
        }

        if (listElement) {
          masterTimeline.to(
            ".content__container__list",
            {
              y: 0, // back to first word
              duration: 0.5,
              ease: "elastic.out(1, 0.6)",
            },
            totalDuration - 0.3
          );
        }
      }); // This closes the requestAnimationFrame callback
    }

    function handleResize() {
      // Clear existing timeout
      clearTimeout(resizeTimeout);

      // Debounce resize events
      resizeTimeout = setTimeout(() => {
        createAnimation();
      }, 250);
    }

    // Initialize animation when page loads
    window.addEventListener("load", () => {
      createAnimation();
    });

    // Handle window resize
    window.addEventListener("resize", handleResize);

    // Handle orientation change on mobile devices
    window.addEventListener("orientationchange", () => {
      setTimeout(() => {
        createAnimation();
      }, 100);
    });
  }
}
